import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import AppInput from '../../../../common/AppInput';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import RipleyComIcon from '../../../../common/icons/color/icr_ripleycom.svg';
import { FIELDS } from './validation/fields';
import { COMPLETE_FORM } from '../../../../../constants/texts';
import { useRemoveClientStyles } from './styles';

const Form = ({ ...props }) => {
  const { state, onData, mobile } = props;
  const classes = useRemoveClientStyles({ mobile });

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  return (
    <React.Fragment>
      <MotiveTitle
        icon={RipleyComIcon}
        title="Compras en ripley.com"
        subtitle="No recibir publicidad de Ripley"
        mobile={mobile}
      />

      <Typography className={classes.title}>{COMPLETE_FORM}</Typography>

      {FIELDS.map((field, index) => (
        <AppInput
          key={index}
          onChange={handleChange}
          onBlur={() => {}}
          onClick={() => {}}
          disabled={state[field.name]?.disabled || false}
          name={field.name}
          error={state[field.name]?.error || false}
          type={state[field.name]?.type || ''}
          label={state[field.name]?.label || ''}
          required={state[field.name]?.required || false}
          inputAdornment={state[field.name]?.inputAdornment || ''}
          success={state[field.name]?.success || false}
          helperText={state[field.name]?.helper || ''}
          multiline={state[field.name]?.multiline || false}
          rows={state[field.name]?.rows || ''}
          value={state[field.name]?.value || ''}
          errorMessage={state[field.name]?.message || ''}
        />
      ))}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  mobile: PropTypes.bool,
};

export default Form;
